<template>
  <footer class="footer-completo">
    <div class="footer">
      <img src="../../assets/logo-Governo-2025.svg" alt="Logo do Governo" />
    </div>
    <div class="powered-by-wrapper">
      <p>powered by <span>GT4W</span></p>
    </div>
  </footer>
</template>
<style scoped>
.footer-completo {
  text-align: left;
  padding: 1rem 0;
  background-color: #295661;
  color: white;
  width: 100%;
  z-index: 99999;
  height: 75px;
  position: relative;
}
.footer img {
  height: 43px;
  margin-left: 30px;
  margin-bottom: 0.7rem;
}
.powered-by-wrapper {
  font-size: 16px;
  text-align: center;
  background-color: #1f4751;
  width: 100%;
  padding: 7px 0;
  margin: 0;
}

.powered-by-wrapper p {
  font-weight: 900;
  font-style: italic;
}
.powered-by-wrapper p span {
  font-weight: normal;
}
</style>
<script>
export default {
  name: "FooterBar"
};
</script>
